var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPlatformCost(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1194_12052)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 24C5.3724 24 0 18.6276 0 12C0 5.3724 5.3724 0 12 0C18.6276 0 24 5.3724 24 12C24 18.6276 18.6276 24 12 24ZM7.8 14.4V16.8H10.8V19.2H13.2V16.8H14.4C15.1957 16.8 15.9587 16.4839 16.5213 15.9213C17.0839 15.3587 17.4 14.5957 17.4 13.8C17.4 13.0044 17.0839 12.2413 16.5213 11.6787C15.9587 11.1161 15.1957 10.8 14.4 10.8H9.6C9.44087 10.8 9.28826 10.7368 9.17574 10.6243C9.06321 10.5117 9 10.3591 9 10.2C9 10.0409 9.06321 9.88826 9.17574 9.77574C9.28826 9.66321 9.44087 9.6 9.6 9.6H16.2V7.2H13.2V4.8H10.8V7.2H9.6C8.80435 7.2 8.04129 7.51607 7.47868 8.07868C6.91607 8.64129 6.6 9.40435 6.6 10.2C6.6 10.9957 6.91607 11.7587 7.47868 12.3213C8.04129 12.8839 8.80435 13.2 9.6 13.2H14.4C14.5591 13.2 14.7117 13.2632 14.8243 13.3757C14.9368 13.4883 15 13.6409 15 13.8C15 13.9591 14.9368 14.1117 14.8243 14.2243C14.7117 14.3368 14.5591 14.4 14.4 14.4H7.8Z",
    fill: "#003771"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1194_12052"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlatformCost);
export default __webpack_public_path__ + "static/media/Platform Cost.953cf355c112730a3da1f30bf90f5668.svg";
export { ForwardRef as ReactComponent };